// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*

Reseting default animation settings

*/

#NavDrawer,
#NavDrawer *,
#NavDrawer > * > *
#NavDrawer > * > * > *
#NavDrawer > * > * > * > *
#NavDrawer > * > * > * > * > *
#NavDrawer > * > * > * > * > * *,
 {
  -o-transition: unset !important;
  -moz-transition: unset !important;
  -ms-transition: unset !important;
  -webkit-transition: unset !important;
  transition: unset !important;
  /*CSS transitions*/
  -o-transition-property: unset !important;
  -moz-transition-property: unset !important;
  -ms-transition-property: unset !important;
  -webkit-transition-property: unset !important;
  transition-property: unset !important;
  /*CSS transforms*/
  -o-transform: unset !important;
  -moz-transform: unset !important;
  -ms-transform: unset !important;
  -webkit-transform: unset !important;
  transform: unset !important;
  /*CSS animations*/
  -webkit-animation: unset !important;
  -moz-animation: unset !important;
  -o-animation: unset !important;
  -ms-animation: unset !important;
  animation: unset !important;

  -o-zoom: none !important;
  -moz-zoom: none !important;
  -ms-zoom: none !important;
  -webkit-zoom: none !important;
  zoom: none !important;

  -o-animation-duration: 0s !important;
  -moz-animation-duration: 0s !important;
  -ms-animation-duration: 0s !important;
  -webkit-animation-duration: 0s !important;
  animation-duration: 0s !important;

  -o-animation-delay: 0s !important;
  -moz-animation-delay: 0s !important;
  -ms-animation-delay: 0s !important;
  -webkit-animation-delay: 0s !important;
  animation-delay: 0s !important;

  -o-transition-duration: 0s !important;
  -moz-transition-duration: 0s !important;
  -ms-transition-duration: 0s !important;
  -webkit-transition-duration: 0s !important;
  transition-duration: 0s !important;

  -o-transition-delay: 0s !important;
  -moz-transition-delay: 0s !important;
  -ms-transition-delay: 0s !important;
  -webkit-transition-delay: 0s !important;
  transition-delay: 0s !important;
}

/*

DRAWER ANIMATION

*/

/* Initial state of Navigation Drawer */
.drawerStart,
.drawerStart *,
.drawerStart * > *,
.drawerStart * > * > *,
.drawerStart .mainMenu,
.drawerStart .mainMenu > *,
.drawerStart span.label,
.drawerStart .LogOut,
.drawerStart div.ant-layout-sider-trigger,
.drawerStart .ant-layout-sider-trigger i{
  transition: none !important;
  animation: none !important;
}

/* Prevent ghoast animation after initial state */
.drawerStart h1,
.drawerStart h2{
  animation: fadeLogosExpandDelay 0s !important;
}
/* Prevent ghoast animation after initial state */
.drawerStart .mainMenu{
  animation: appearingMenuExpandDelay 0s !important;
}
/* Prevent ghoast animation after initial state */
.drawerStart .allApps-menu{
  animation: disappearingOutMenuExpandDelay 0s !important;
}

/* Drawer transition settings  */
.drawerMainMenu,
.drawerAllAppsMenu,
.drawerCollapsed {
  background-color: #fff !important;
  transition:
  width .3s,
  max-width .3s,
  min-width .3s
  !important;
}
/* Logo Block settings */
.drawerMainMenu .logo,
.drawerAllAppsMenu .logo,
.drawerCollapsed .logo{
  transition:
  width .3s,
  margin-left .3s,
  margin-right .3s
  !important;
}

/*

All Apps Button Animation

*/
.drawerCollapsed .all-apps-btn{
  animation: fadeAllAppsCollapseDelay .3s !important;
}
.drawerAllAppsMenu .all-apps-btn,
.drawerMainMenu .all-apps-btn{
  animation: fadeAllAppsExpandDelay .3s !important;
}

@keyframes fadeAllAppsCollapseDelay{
  0% {
    visibility: hidden;
    opacity: 0;
    top: 0;
    left:auto;
    right: 0;
  }
  50% {
    top: 0;
    left:auto;
    right: 0;
  }
  51%{
    visibility: hidden;
    opacity: 0;
    left: 0;
    right: auto;
    top: 60px;
  }
  100% {
    visibility: visible;
    opacity: 1;
  }
}
@keyframes fadeAllAppsExpandDelay{
  0%,50% {
    visibility: hidden;
    opacity: 0;
    left: 0;
    right: auto;
    top: 60px;
  }
  51%{
    visibility: hidden;
    opacity: 0;
    top: 0;
    left:auto;
    right: 0;
  }
  100%{
    visibility: visible;
    opacity: 1;
    top: 0;
    left:auto;
    right: 0;
  }
}

/* Turing and Apps titles animation */

.drawerCollapsed h1,
.drawerCollapsed h2{
  animation: fadeLogosCollapsing .3s !important;
}
.drawerAllAppsMenu h1,
.drawerAllAppsMenu h2,
.drawerMainMenu h1,
.drawerMainMenu h2{
  animation: fadeLogosExpandDelay .3s !important;
}
@keyframes fadeLogosCollapsing{
  0%{
    visibility: visible;
    opacity: 1;
  }
  50%, 100%{
    visibility: visible;
    opacity: 0;
  }
}

@keyframes fadeLogosExpandDelay{
  0%,10%{
    opacity: 0;
    visibility: hidden;
  }
  100%{
    opacity: 1;
    visibility: visible;
  }
}

/*

Menu animations

*/

/* Main menu */
.drawerMainMenu .mainMenu,
.drawerCollapsed .mainMenu,
.drawerAllAppsMenu .mainMenu{
  transition:
  margin .3s,
  width .3s
  !important;
}

/* All Apps menu */
.drawerMainMenu .allApps-menu,
.drawerCollapsed .allApps-menu,
.drawerAllAppsMenu .allApps-menu{
  transition:
  width .3s
  !important;
}

/* Menu items (Single items and Parent Titles) */
.drawerCollapsed .ant-menu-item,
.drawerMainMenu .ant-menu-item,
.drawerAllAppsMenu .ant-menu-item,

.drawerAllAppsMenu span.container,
.drawerMainMenu span.container,
.drawerCollapsed  span.container{
  transition:
  all .3s
  !important;
}

/* Submenu expanding / collapsing */
.ant-menu-submenu{
  max-height:52px !important;
}
.ant-menu-submenu-open{
  max-height:1000rem !important;
}
#NavDrawer .ant-menu-submenu{
  transition:
  max-height .3s
  ease
  !important;
}
/* Main menu */
.drawerCollapsed .mainMenu,
.drawerMainMenu .mainMenu,
.drawerAllAppsMenu .allApps-menu{
}
.drawerAllAppsMenu .mainMenu,
.drawerCollapsed .allApps-menu,
.drawerMainMenu .allApps-menu{
  animation: disappearingOutMenuExpandDelay .3s !important;
}

@keyframes appearingMenuExpandDelay{
  0%, 39%{
    padding-bottom: 0px;
    opacity: 0;
    visibility: hidden;
    height: 0;
    overflow: hidden;
    text-overflow: hidden;
  }
  40%{
    opacity: 0;
    visibility: visible;
    height: auto;
    overflow: visible;
    text-overflow: visible;
  }
  100%{
    opacity: 1;
    visibility: visible;
    height: auto;
    overflow: visible;
    text-overflow: ellipsis;
  }
}
@keyframes disappearingOutMenuExpandDelay{
  0%{
    opacity: 1;
    visibility: visible;
    height: auto;
    overflow: visible;
  }
  29%{
    opacity: 0;
    visibility: visible;
    height: auto;
    overflow: visible;
  }
  30%, 100%{
    opacity: 0;
    visibility: hidden;
    height: 0;
    overflow: hidden;
  }
}

/*

Navigator grid settings changes

*/
.drawerStart .ant-layout-sider-children,
.drawerCollapsed .ant-layout-sider-children,
.drawerMainMenu .ant-layout-sider-children{
  animation: hideAllApps .3s !important;
}
@keyframes hideAllApps {
  0%{
    grid-template-rows: 216px 0 1fr !important;
  }
  49%, 100%{
    grid-template-rows: 216px 1fr 0 !important;
  }
}

.drawerAllAppsMenu .ant-layout-sider-children{
  animation: hideMainMenu .3s !important;
}
@keyframes hideMainMenu {
  0%{
    grid-template-rows: 216px 1fr 0 !important;
  }
  49%,100%{
    grid-template-rows: 216px 0 1fr !important;
  }
}

@keyframes menuItemPadding{
  0%{
    padding: 3px 0 0 13px;
    width:54px;
  }
  100%{
    padding: 3px 16px;
    width: 302px !important;
  }
}
.drawerCollapsed .ant-menu-item .label
.drawerCollapsed .ant-menu-submenu-title > span > .label{
  text-overflow: visible !important;
}

.drawerMainMenu .ant-menu-submenu .material-icons{
  animation: unset !important;
  margin-left: 0px !important;
}
@keyframes fadeLabelsExpandDelay{
  0%{
    opacity: 0;
    visibility: hidden;
    text-overflow: visible !important;
  }
  30%{
    opacity: 0;
    visibility: hidden;
    text-overflow: visible;
  }
  100%{
    opacity: 1;
    visibility: visible;
    text-overflow: ellipsis
  }
}

.mainMenu > .ant-menu-submenu,
.mainMenu > .ant-menu-submenu-title,
.mainMenu > .ant-menu-submenu > .ant-menu-sub{
  width: 100% !important;
}
.launchScreen  .ant-menu-item,
#NavDrawer .ant-menu-item,
#NavDrawer  .mainMenu  .ant-menu-submenu-title > .container{
  display: grid !important;
  grid-template-columns: 48px 1fr !important;
  align-items: center;
  align-content: stretch;
  justify-items: flex-start;
  width: 100% !important;
}

.drawerCollapsed  .ant-menu-item,
.drawerCollapsed  .ant-menu-submenu-title > .container
.drawerAllAppsMenu .mainMenu .ant-menu-item,
.drawerAllAppsMenu .ant-menu-submenu-title > .container{
  justify-items: flex-start;
}
#NavDrawer i.ant-menu-submenu-arrow,
#NavDrawer.drawerMainMenu span.label
#NavDrawer.drawerAllAppsMenu span.label{
  animation: fadeInLabels .3s !important;
}
#NavDrawer.drawerCollapsed i.ant-menu-submenu-arrow,
#NavDrawer.drawerCollapsed span.label{
  animation: fadeOutLabels .3s !important;
}
@keyframes fadeOutLabels {
  0%{
    opacity: 1;
    visibility: visible;
  }
  50%,100%{
    opacity: 0;
    visibility: hidden;
  }
}
body, #NavDrawer.drawerStart{
  animation: fadeInLabels .3s !important;
}
@keyframes fadeInLabels {
  0%,25%{
    opacity: 0;
    visibility: hidden;

  }
  100%{
    opacity: 1;
    visibility: visible;
  }
}

/*

Log Out animation

*/

.drawerCollapsed .LogOut .LogOutText{
  text-align: center;
  animation: fadeOutLabels .3s !important;
}

.drawerMainMenu  .LogOut .LogOutText{
  animation: fadeLabelsExpandDelay .3s !important;
}
.drawerCollapsed .LogOut,
.drawerMainMenu .LogOut,
.drawerAllAppsMenu .LogOut{
  margin: 0 !important;
  text-align: left;
}

.LogOut{
  text-align: left;
  transition:
          padding .3s,
          width .3s,
  !important;
}

/*
Slider Animation
*/
.drawerCollapsed .ant-layout-sider-trigger,
.drawerMainMenu .ant-layout-sider-trigger,
.drawerAllAppsMenu .ant-layout-sider-trigger{
  transition:
  width .3s,
  max-width .3s,
  min-width .3s
  !important;
}

/* Content animation */
.contentColumn .Paper{
  transition:
  max-width .3s
  !important;
}
`, "",{"version":3,"sources":["webpack://./src/v3/assets/css/Animations.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;;;;;;;;EAQE,+BAA+B;EAC/B,iCAAiC;EACjC,gCAAgC;EAChC,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;EACzC,6CAA6C;EAC7C,qCAAqC;EACrC,iBAAiB;EACjB,8BAA8B;EAC9B,gCAAgC;EAChC,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;EAC3B,iBAAiB;EACjB,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;;EAE3B,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;;EAErB,oCAAoC;EACpC,sCAAsC;EACtC,qCAAqC;EACrC,yCAAyC;EACzC,iCAAiC;;EAEjC,iCAAiC;EACjC,mCAAmC;EACnC,kCAAkC;EAClC,sCAAsC;EACtC,8BAA8B;;EAE9B,qCAAqC;EACrC,uCAAuC;EACvC,sCAAsC;EACtC,0CAA0C;EAC1C,kCAAkC;;EAElC,kCAAkC;EAClC,oCAAoC;EACpC,mCAAmC;EACnC,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;;;;CAIC;;AAED,uCAAuC;AACvC;;;;;;;;;;EAUE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,iDAAiD;AACjD;;EAEE,6CAA6C;AAC/C;AACA,iDAAiD;AACjD;EACE,iDAAiD;AACnD;AACA,iDAAiD;AACjD;EACE,uDAAuD;AACzD;;AAEA,gCAAgC;AAChC;;;EAGE,iCAAiC;EACjC;;;;YAIU;AACZ;AACA,wBAAwB;AACxB;;;EAGE;;;;YAIU;AACZ;;AAEA;;;;CAIC;AACD;EACE,kDAAkD;AACpD;AACA;;EAEE,gDAAgD;AAClD;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,QAAQ;EACV;EACA;IACE,MAAM;IACN,SAAS;IACT,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,WAAW;IACX,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,WAAW;IACX,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,QAAQ;EACV;EACA;IACE,mBAAmB;IACnB,UAAU;IACV,MAAM;IACN,SAAS;IACT,QAAQ;EACV;AACF;;AAEA,qCAAqC;;AAErC;;EAEE,6CAA6C;AAC/C;AACA;;;;EAIE,8CAA8C;AAChD;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;;;;CAIC;;AAED,cAAc;AACd;;;EAGE;;;YAGU;AACZ;;AAEA,kBAAkB;AAClB;;;EAGE;;YAEU;AACZ;;AAEA,gDAAgD;AAChD;;;;;;;EAOE;;YAEU;AACZ;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;;;YAGU;AACZ;AACA,cAAc;AACd;;;AAGA;AACA;;;EAGE,wDAAwD;AAC1D;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,gBAAgB;EAClB;AACF;;AAEA;;;;CAIC;AACD;;;EAGE,qCAAqC;AACvC;AACA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;AACF;AACA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB;EACF;AACF;;AAEA;;;EAGE,sBAAsB;AACxB;AACA;;;EAGE,wBAAwB;EACxB,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;;EAIE,yBAAyB;AAC3B;AACA;;;EAGE,sCAAsC;AACxC;AACA;;EAEE,uCAAuC;AACzC;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,UAAU;IACV,kBAAkB;;EAEpB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;;;;CAIC;;AAED;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;AACjD;AACA;;;EAGE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB;;;YAGU;AACZ;;AAEA;;CAEC;AACD;;;EAGE;;;;YAIU;AACZ;;AAEA,sBAAsB;AACtB;EACE;;YAEU;AACZ","sourcesContent":["/*\n\nReseting default animation settings\n\n*/\n\n#NavDrawer,\n#NavDrawer *,\n#NavDrawer > * > *\n#NavDrawer > * > * > *\n#NavDrawer > * > * > * > *\n#NavDrawer > * > * > * > * > *\n#NavDrawer > * > * > * > * > * *,\n {\n  -o-transition: unset !important;\n  -moz-transition: unset !important;\n  -ms-transition: unset !important;\n  -webkit-transition: unset !important;\n  transition: unset !important;\n  /*CSS transitions*/\n  -o-transition-property: unset !important;\n  -moz-transition-property: unset !important;\n  -ms-transition-property: unset !important;\n  -webkit-transition-property: unset !important;\n  transition-property: unset !important;\n  /*CSS transforms*/\n  -o-transform: unset !important;\n  -moz-transform: unset !important;\n  -ms-transform: unset !important;\n  -webkit-transform: unset !important;\n  transform: unset !important;\n  /*CSS animations*/\n  -webkit-animation: unset !important;\n  -moz-animation: unset !important;\n  -o-animation: unset !important;\n  -ms-animation: unset !important;\n  animation: unset !important;\n\n  -o-zoom: none !important;\n  -moz-zoom: none !important;\n  -ms-zoom: none !important;\n  -webkit-zoom: none !important;\n  zoom: none !important;\n\n  -o-animation-duration: 0s !important;\n  -moz-animation-duration: 0s !important;\n  -ms-animation-duration: 0s !important;\n  -webkit-animation-duration: 0s !important;\n  animation-duration: 0s !important;\n\n  -o-animation-delay: 0s !important;\n  -moz-animation-delay: 0s !important;\n  -ms-animation-delay: 0s !important;\n  -webkit-animation-delay: 0s !important;\n  animation-delay: 0s !important;\n\n  -o-transition-duration: 0s !important;\n  -moz-transition-duration: 0s !important;\n  -ms-transition-duration: 0s !important;\n  -webkit-transition-duration: 0s !important;\n  transition-duration: 0s !important;\n\n  -o-transition-delay: 0s !important;\n  -moz-transition-delay: 0s !important;\n  -ms-transition-delay: 0s !important;\n  -webkit-transition-delay: 0s !important;\n  transition-delay: 0s !important;\n}\n\n/*\n\nDRAWER ANIMATION\n\n*/\n\n/* Initial state of Navigation Drawer */\n.drawerStart,\n.drawerStart *,\n.drawerStart * > *,\n.drawerStart * > * > *,\n.drawerStart .mainMenu,\n.drawerStart .mainMenu > *,\n.drawerStart span.label,\n.drawerStart .LogOut,\n.drawerStart div.ant-layout-sider-trigger,\n.drawerStart .ant-layout-sider-trigger i{\n  transition: none !important;\n  animation: none !important;\n}\n\n/* Prevent ghoast animation after initial state */\n.drawerStart h1,\n.drawerStart h2{\n  animation: fadeLogosExpandDelay 0s !important;\n}\n/* Prevent ghoast animation after initial state */\n.drawerStart .mainMenu{\n  animation: appearingMenuExpandDelay 0s !important;\n}\n/* Prevent ghoast animation after initial state */\n.drawerStart .allApps-menu{\n  animation: disappearingOutMenuExpandDelay 0s !important;\n}\n\n/* Drawer transition settings  */\n.drawerMainMenu,\n.drawerAllAppsMenu,\n.drawerCollapsed {\n  background-color: #fff !important;\n  transition:\n  width .3s,\n  max-width .3s,\n  min-width .3s\n  !important;\n}\n/* Logo Block settings */\n.drawerMainMenu .logo,\n.drawerAllAppsMenu .logo,\n.drawerCollapsed .logo{\n  transition:\n  width .3s,\n  margin-left .3s,\n  margin-right .3s\n  !important;\n}\n\n/*\n\nAll Apps Button Animation\n\n*/\n.drawerCollapsed .all-apps-btn{\n  animation: fadeAllAppsCollapseDelay .3s !important;\n}\n.drawerAllAppsMenu .all-apps-btn,\n.drawerMainMenu .all-apps-btn{\n  animation: fadeAllAppsExpandDelay .3s !important;\n}\n\n@keyframes fadeAllAppsCollapseDelay{\n  0% {\n    visibility: hidden;\n    opacity: 0;\n    top: 0;\n    left:auto;\n    right: 0;\n  }\n  50% {\n    top: 0;\n    left:auto;\n    right: 0;\n  }\n  51%{\n    visibility: hidden;\n    opacity: 0;\n    left: 0;\n    right: auto;\n    top: 60px;\n  }\n  100% {\n    visibility: visible;\n    opacity: 1;\n  }\n}\n@keyframes fadeAllAppsExpandDelay{\n  0%,50% {\n    visibility: hidden;\n    opacity: 0;\n    left: 0;\n    right: auto;\n    top: 60px;\n  }\n  51%{\n    visibility: hidden;\n    opacity: 0;\n    top: 0;\n    left:auto;\n    right: 0;\n  }\n  100%{\n    visibility: visible;\n    opacity: 1;\n    top: 0;\n    left:auto;\n    right: 0;\n  }\n}\n\n/* Turing and Apps titles animation */\n\n.drawerCollapsed h1,\n.drawerCollapsed h2{\n  animation: fadeLogosCollapsing .3s !important;\n}\n.drawerAllAppsMenu h1,\n.drawerAllAppsMenu h2,\n.drawerMainMenu h1,\n.drawerMainMenu h2{\n  animation: fadeLogosExpandDelay .3s !important;\n}\n@keyframes fadeLogosCollapsing{\n  0%{\n    visibility: visible;\n    opacity: 1;\n  }\n  50%, 100%{\n    visibility: visible;\n    opacity: 0;\n  }\n}\n\n@keyframes fadeLogosExpandDelay{\n  0%,10%{\n    opacity: 0;\n    visibility: hidden;\n  }\n  100%{\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n/*\n\nMenu animations\n\n*/\n\n/* Main menu */\n.drawerMainMenu .mainMenu,\n.drawerCollapsed .mainMenu,\n.drawerAllAppsMenu .mainMenu{\n  transition:\n  margin .3s,\n  width .3s\n  !important;\n}\n\n/* All Apps menu */\n.drawerMainMenu .allApps-menu,\n.drawerCollapsed .allApps-menu,\n.drawerAllAppsMenu .allApps-menu{\n  transition:\n  width .3s\n  !important;\n}\n\n/* Menu items (Single items and Parent Titles) */\n.drawerCollapsed .ant-menu-item,\n.drawerMainMenu .ant-menu-item,\n.drawerAllAppsMenu .ant-menu-item,\n\n.drawerAllAppsMenu span.container,\n.drawerMainMenu span.container,\n.drawerCollapsed  span.container{\n  transition:\n  all .3s\n  !important;\n}\n\n/* Submenu expanding / collapsing */\n.ant-menu-submenu{\n  max-height:52px !important;\n}\n.ant-menu-submenu-open{\n  max-height:1000rem !important;\n}\n#NavDrawer .ant-menu-submenu{\n  transition:\n  max-height .3s\n  ease\n  !important;\n}\n/* Main menu */\n.drawerCollapsed .mainMenu,\n.drawerMainMenu .mainMenu,\n.drawerAllAppsMenu .allApps-menu{\n}\n.drawerAllAppsMenu .mainMenu,\n.drawerCollapsed .allApps-menu,\n.drawerMainMenu .allApps-menu{\n  animation: disappearingOutMenuExpandDelay .3s !important;\n}\n\n@keyframes appearingMenuExpandDelay{\n  0%, 39%{\n    padding-bottom: 0px;\n    opacity: 0;\n    visibility: hidden;\n    height: 0;\n    overflow: hidden;\n    text-overflow: hidden;\n  }\n  40%{\n    opacity: 0;\n    visibility: visible;\n    height: auto;\n    overflow: visible;\n    text-overflow: visible;\n  }\n  100%{\n    opacity: 1;\n    visibility: visible;\n    height: auto;\n    overflow: visible;\n    text-overflow: ellipsis;\n  }\n}\n@keyframes disappearingOutMenuExpandDelay{\n  0%{\n    opacity: 1;\n    visibility: visible;\n    height: auto;\n    overflow: visible;\n  }\n  29%{\n    opacity: 0;\n    visibility: visible;\n    height: auto;\n    overflow: visible;\n  }\n  30%, 100%{\n    opacity: 0;\n    visibility: hidden;\n    height: 0;\n    overflow: hidden;\n  }\n}\n\n/*\n\nNavigator grid settings changes\n\n*/\n.drawerStart .ant-layout-sider-children,\n.drawerCollapsed .ant-layout-sider-children,\n.drawerMainMenu .ant-layout-sider-children{\n  animation: hideAllApps .3s !important;\n}\n@keyframes hideAllApps {\n  0%{\n    grid-template-rows: 216px 0 1fr !important;\n  }\n  49%, 100%{\n    grid-template-rows: 216px 1fr 0 !important;\n  }\n}\n\n.drawerAllAppsMenu .ant-layout-sider-children{\n  animation: hideMainMenu .3s !important;\n}\n@keyframes hideMainMenu {\n  0%{\n    grid-template-rows: 216px 1fr 0 !important;\n  }\n  49%,100%{\n    grid-template-rows: 216px 0 1fr !important;\n  }\n}\n\n@keyframes menuItemPadding{\n  0%{\n    padding: 3px 0 0 13px;\n    width:54px;\n  }\n  100%{\n    padding: 3px 16px;\n    width: 302px !important;\n  }\n}\n.drawerCollapsed .ant-menu-item .label\n.drawerCollapsed .ant-menu-submenu-title > span > .label{\n  text-overflow: visible !important;\n}\n\n.drawerMainMenu .ant-menu-submenu .material-icons{\n  animation: unset !important;\n  margin-left: 0px !important;\n}\n@keyframes fadeLabelsExpandDelay{\n  0%{\n    opacity: 0;\n    visibility: hidden;\n    text-overflow: visible !important;\n  }\n  30%{\n    opacity: 0;\n    visibility: hidden;\n    text-overflow: visible;\n  }\n  100%{\n    opacity: 1;\n    visibility: visible;\n    text-overflow: ellipsis\n  }\n}\n\n.mainMenu > .ant-menu-submenu,\n.mainMenu > .ant-menu-submenu-title,\n.mainMenu > .ant-menu-submenu > .ant-menu-sub{\n  width: 100% !important;\n}\n.launchScreen  .ant-menu-item,\n#NavDrawer .ant-menu-item,\n#NavDrawer  .mainMenu  .ant-menu-submenu-title > .container{\n  display: grid !important;\n  grid-template-columns: 48px 1fr !important;\n  align-items: center;\n  align-content: stretch;\n  justify-items: flex-start;\n  width: 100% !important;\n}\n\n.drawerCollapsed  .ant-menu-item,\n.drawerCollapsed  .ant-menu-submenu-title > .container\n.drawerAllAppsMenu .mainMenu .ant-menu-item,\n.drawerAllAppsMenu .ant-menu-submenu-title > .container{\n  justify-items: flex-start;\n}\n#NavDrawer i.ant-menu-submenu-arrow,\n#NavDrawer.drawerMainMenu span.label\n#NavDrawer.drawerAllAppsMenu span.label{\n  animation: fadeInLabels .3s !important;\n}\n#NavDrawer.drawerCollapsed i.ant-menu-submenu-arrow,\n#NavDrawer.drawerCollapsed span.label{\n  animation: fadeOutLabels .3s !important;\n}\n@keyframes fadeOutLabels {\n  0%{\n    opacity: 1;\n    visibility: visible;\n  }\n  50%,100%{\n    opacity: 0;\n    visibility: hidden;\n  }\n}\nbody, #NavDrawer.drawerStart{\n  animation: fadeInLabels .3s !important;\n}\n@keyframes fadeInLabels {\n  0%,25%{\n    opacity: 0;\n    visibility: hidden;\n\n  }\n  100%{\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n/*\n\nLog Out animation\n\n*/\n\n.drawerCollapsed .LogOut .LogOutText{\n  text-align: center;\n  animation: fadeOutLabels .3s !important;\n}\n\n.drawerMainMenu  .LogOut .LogOutText{\n  animation: fadeLabelsExpandDelay .3s !important;\n}\n.drawerCollapsed .LogOut,\n.drawerMainMenu .LogOut,\n.drawerAllAppsMenu .LogOut{\n  margin: 0 !important;\n  text-align: left;\n}\n\n.LogOut{\n  text-align: left;\n  transition:\n          padding .3s,\n          width .3s,\n  !important;\n}\n\n/*\nSlider Animation\n*/\n.drawerCollapsed .ant-layout-sider-trigger,\n.drawerMainMenu .ant-layout-sider-trigger,\n.drawerAllAppsMenu .ant-layout-sider-trigger{\n  transition:\n  width .3s,\n  max-width .3s,\n  min-width .3s\n  !important;\n}\n\n/* Content animation */\n.contentColumn .Paper{\n  transition:\n  max-width .3s\n  !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
